module.exports = __webpack_public_path__ + "static/media/UserRounded_black.72bd42ab.svg";